<template>
	<div>
		<template v-if="store.calculator === 'poster'">
			<div
				class="icg-calc__form-wrap"
				v-if="fieldName === 'coating' && store.paperIsCover === 'true'"
			>
				<div class="icg-calc__form-wrap-flex">
					<FieldLabel
						:forText="fieldName"
						:label="fieldLabel"
						:helpText="fieldHelpText"
					/>
					<Field :name="fieldName" :data="fieldData" />
				</div>
			</div>
			<div
				class="icg-calc__form-wrap"
				v-else-if="fieldName !== 'coating'"
				v-show="fieldData.type !== 'hidden'"
			>
				<div
					class="icg-calc__form-wrap-flex"
					:class="{ 'flex-reverse': fieldData.type === 'checkbox' }"
				>
					<FieldLabel
						:forText="fieldName"
						:label="fieldLabel"
						:helpText="fieldHelpText"
					/>
					<Field :name="fieldName" :data="fieldData" />
				</div>
			</div>
		</template>
		<template v-else>
			<template v-if="fieldName === 'binding'">
				<div
					class="icg-calc__form-wrap"
					v-show="store.bindingOptions.length"
				>
					<div class="icg-calc__form-wrap-flex">
						<FieldLabel
							:forText="fieldName"
							:label="fieldLabel"
							:helpText="fieldHelpText"
						/>
						<Field :name="fieldName" :data="fieldData" />
					</div>
				</div>
			</template>
			<!-- TODO: move logic into API -->
			<template v-else-if="fieldName === 'coating'">
				<div
					class="icg-calc__form-wrap"
					v-if="store.calculator !== 'newsletter'"
				>
					<div class="icg-calc__form-wrap-flex">
						<FieldLabel
							:forText="fieldName"
							:label="fieldLabel"
							:helpText="fieldHelpText"
						/>
						<Field :name="fieldName" :data="fieldData" />
					</div>
				</div>
			</template>
			<!-- TODO: move logic into API -->
			<template v-else-if="fieldName === 'plastic_coil_color'">
				<div
					class="icg-calc__form-wrap"
					v-show="store.bindingName === 'Plastic Coil'"
				>
					<div class="icg-calc__form-wrap-flex">
						<FieldLabel
							:forText="fieldName"
							:label="fieldLabel"
							:helpText="fieldHelpText"
						/>
						<Field :name="fieldName" :data="fieldData" />
					</div>
				</div>
			</template>
			<!-- TODO: move logic into API -->
			<template v-else-if="fieldName === 'wireo_color'">
				<div
					class="icg-calc__form-wrap"
					v-show="store.bindingName === 'Wire-O'"
				>
					<div class="icg-calc__form-wrap-flex">
						<FieldLabel
							:forText="fieldName"
							:label="fieldLabel"
							:helpText="fieldHelpText"
						/>
						<Field :name="fieldName" :data="fieldData" />
					</div>
				</div>
			</template>
			<!-- TODO: move logic into API -->
			<template v-else-if="fieldName === 'plastic_cover_front'">
				<div
					class="icg-calc__form-wrap"
					v-show="
						store.bindingName === 'Wire-O' ||
							store.bindingName === 'Plastic Coil' ||
							store.bindingName === 'None'
					"
				>
					<div class="icg-calc__form-wrap-flex">
						<FieldLabel
							:forText="fieldName"
							:label="fieldLabel"
							:helpText="fieldHelpText"
						/>
						<Field :name="fieldName" :data="fieldData" />
					</div>
				</div>
			</template>
			<!-- TODO: move logic into API -->
			<template v-else-if="fieldName === 'plastic_cover_back'">
				<div
					class="icg-calc__form-wrap"
					v-show="
						store.bindingName === 'Wire-O' ||
							store.bindingName === 'Plastic Coil' ||
							store.bindingName === 'None'
					"
				>
					<div class="icg-calc__form-wrap-flex">
						<FieldLabel
							:forText="fieldName"
							:label="fieldLabel"
							:helpText="fieldHelpText"
						/>
						<Field :name="fieldName" :data="fieldData" />
					</div>
				</div>
			</template>
			<template v-else>
				<div
					class="icg-calc__form-wrap"
					v-show="fieldData.type !== 'hidden'"
				>
					<div
						class="icg-calc__form-wrap-flex"
						:class="{
							'flex-reverse': fieldData.type === 'checkbox'
						}"
					>
						<FieldLabel
							:forText="fieldName"
							:label="fieldLabel"
							:helpText="fieldHelpText"
						/>
						<Field :name="fieldName" :data="fieldData" />
					</div>
				</div>
			</template>
		</template>
	</div>
</template>

<script>
import { store } from "../store";
import Field from "./Field.vue";
import FieldLabel from "./FieldLabel.vue";

export default {
	components: {
		Field,
		FieldLabel
	},

	computed: {
		fieldLabel() {
			return this.fieldData.label !== null
				? this.fieldData.label[0].text.length > 0
					? this.fieldData.label[0].text
					: "No Label"
				: "No Label";
		},

		fieldHelpText() {
			return this.fieldData.label !== null
				? this.fieldData.label[0].help_text.length > 0
					? this.fieldData.label[0].help_text
					: ""
				: "";
		}
	},

	data() {
		return {
			store: store
		};
	},

	props: {
		fieldData: {
			type: Object,
			required: true
		},

		fieldName: {
			type: String,
			required: true
		}
	}
};
</script>
